import React from 'react';

// Black wordmark on light, white wordmark on dark; CSS shows the right one.
const Logo = ({ className = '' }) => (
  <>
    <img src="/logo-trim.png" alt="enseQure" className={`logo-on-light ${className}`} />
    <img src="/logo-light.png" alt="enseQure" className={`logo-on-dark ${className}`} />
  </>
);

export default Logo;
